import { render, staticRenderFns } from "./NewsNavbar.vue?vue&type=template&id=4b095b1a&scoped=true&"
import script from "./NewsNavbar.vue?vue&type=script&lang=js&"
export * from "./NewsNavbar.vue?vue&type=script&lang=js&"
import style0 from "./NewsNavbar.vue?vue&type=style&index=0&id=4b095b1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b095b1a",
  null
  
)

export default component.exports